// src/api/adminBundleApi.js
import api from './axios';

export const exportBundle = (level='gold', opts={}) =>
  api.get('/admin/lab-bundles/export', { params: { level, ...opts }, responseType: 'blob' });

export const importBundle = (file, dryRun=false) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('dry_run', dryRun);
  return api.post('/admin/lab-bundles/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getBundleLevels  = ()          => api.get('/admin/lab-bundles/levels');
export const updateBundleLevels = (levels)  => api.put('/admin/lab-bundles/levels', levels);
